import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    backgroundColor: theme.palette.tabControl.backgroundColor,
    borderRadius: '10px',
    width: '100%',

    gap: '8px',
    padding: theme.spacing(0.5),
    height: theme.spacing(5.5),
  },
  wrapperFitContent: {
    width: 'fit-content',
    maxWidth: '100%',
  },
  tabs: {
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  },
  tabsScroller: {
    overflow: 'auto !important' as any,
  },
  tabContentWrapper: {},
  tab: {
    display: 'flex',
    fontSize: '14px',
    textTransform: 'none',
    alignItems: 'center',
  },
  tabRoot: {
    // borderBottom: `2px solid ${theme.palette.grey[200]}`,
    transition: 'background-color 0.3s ease',
    borderBottom: 'none',
    borderRadius: '10px',
    color: theme.palette.tabControl.contrastText,
    padding: theme.spacing(1, 2),
    height: theme.spacing(4.5),
    minHeight: 'unset',

    '&:hover': {
      backgroundColor: theme.palette.tabControl.primaryDark,
      color: `${theme.palette.tabControl.contrastTextDark} !important`,
    },
  },
  selectedTab: {
    // borderBottom: `2px solid ${theme.palette.primary.main}`,
    borderBottom: 'none',
    backgroundColor: 'transparent',
    backgroundImage: theme.palette.primaryGradient,
    color: `${theme.palette.tabControl.secondaryContrastText} !important`,

    '&:hover': {
      backgroundImage: `${theme.palette.primaryGradient} !important`,
      color: `${theme.palette.tabControl.secondaryContrastText} !important`,
    },
  },
  muiTabsIndicator: {
    display: 'none',
    backgroundColor: theme.palette.primary.main,
  },
  fullWidthTab: {
    flex: 1,
  },
}));
